// extracted by mini-css-extract-plugin
module.exports = {"containerBoxes":"styles_containerBoxes__31Otv","boxCalculations":"styles_boxCalculations__3IRIZ","formPremiumPercentage":"styles_formPremiumPercentage__9BWQn"};